var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("mandate.fraud_case.title") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "b-col",
                    {
                      staticStyle: { width: "fit-content" },
                      attrs: { cols: "auto" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "back-button-wrapper" },
                        [_c("back-button")],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.caseData
                ? _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-card",
                            [
                              _c(
                                "div",
                                { staticClass: "case-header mb-4" },
                                [
                                  _c("h3", { staticClass: "mb-2 mb-md-0" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.translateFraudValue(
                                          _vm.caseData.type
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-badge",
                                    {
                                      staticClass: "case-severity-badge",
                                      attrs: {
                                        variant: _vm.severityVariant(
                                          _vm.caseData.severity
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.translateFraudValue(
                                              _vm.caseData.severity
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.$t(
                                              "mandate.fraud_case.severity"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: { cols: "12", md: "4" },
                                    },
                                    [
                                      _c("div", { staticClass: "kpi-card" }, [
                                        _c(
                                          "span",
                                          { staticClass: "kpi-label" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "mandate.fraud_case.detected_by"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "strong",
                                          {
                                            staticClass:
                                              "kpi-value kpi-value-small",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.translateFraudValue(
                                                  _vm.caseData.detectedBy
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: { cols: "12", md: "4" },
                                    },
                                    [
                                      _c("div", { staticClass: "kpi-card" }, [
                                        _c(
                                          "span",
                                          { staticClass: "kpi-label" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "mandate.fraud_case.amount_at_risk"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "strong",
                                          { staticClass: "kpi-value" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.caseData.amountLabel)
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: { cols: "12", md: "4" },
                                    },
                                    [
                                      _c("div", { staticClass: "kpi-card" }, [
                                        _c(
                                          "span",
                                          { staticClass: "kpi-label" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "mandate.fraud_case.detection_date"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "strong",
                                          {
                                            staticClass:
                                              "kpi-value kpi-value-small",
                                          },
                                          [_vm._v(_vm._s(_vm.caseData.date))]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("hr", { staticClass: "my-4" }),
                              _vm._v(" "),
                              _c("h5", { staticClass: "mb-3" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "mandate.fraud_case.case_information"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: { cols: "12", md: "6" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "filter-item-title d-block mb-1",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "mandate.fraud_case.sncf_entity"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "detail-value" }, [
                                        _vm._v(_vm._s(_vm.caseData.entity)),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: { cols: "12", md: "6" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "filter-item-title d-block mb-1",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "mandate.fraud_case.fraud_nature"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "detail-value" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.translateFraudValue(
                                              _vm.caseData.type
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: { cols: "12", md: "6" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "filter-item-title d-block mb-1",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "mandate.fraud_case.related_id"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "detail-value" }, [
                                        _c("code", [
                                          _vm._v(
                                            _vm._s(_vm.caseData.relatedId)
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: { cols: "12", md: "6" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "filter-item-title d-block mb-1",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "mandate.fraud_case.current_status"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-badge",
                                        {
                                          attrs: {
                                            variant: _vm.statusVariant(
                                              _vm.caseData.status
                                            ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translateFraudValue(
                                                _vm.caseData.status
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("hr", { staticClass: "my-4" }),
                              _vm._v(" "),
                              _c("h5", { staticClass: "mb-3" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "mandate.fraud_case.detection_details"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "detail-description" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.translateFraudValue(
                                      _vm.caseData.description
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("hr", { staticClass: "my-4" }),
                              _vm._v(" "),
                              _c("h5", { staticClass: "mb-3" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "mandate.fraud_case.investigation_timeline"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "table-responsive" },
                                [
                                  _c("b-table", {
                                    staticClass: "mb-0",
                                    attrs: {
                                      striped: "",
                                      hover: "",
                                      small: "",
                                      items: _vm.translatedTimeline,
                                      fields: _vm.timelineFields,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "cell(actor)",
                                          fn: function (data) {
                                            return [
                                              _c(
                                                "b-badge",
                                                {
                                                  attrs: {
                                                    variant: "secondary",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.translateFraudValue(
                                                        data.value
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3929271489
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.relatedCases.length
                                ? [
                                    _c("hr", { staticClass: "my-4" }),
                                    _vm._v(" "),
                                    _c("h5", { staticClass: "mb-3" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "mandate.fraud_case.related_cases_for_entity"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "table-responsive" },
                                      [
                                        _c("b-table", {
                                          staticClass: "mb-0 clickable-rows",
                                          attrs: {
                                            striped: "",
                                            hover: "",
                                            small: "",
                                            items: _vm.relatedCases,
                                            fields: _vm.relatedCasesFields,
                                          },
                                          on: {
                                            "row-clicked": _vm.goToRelatedCase,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "cell(severity)",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      "b-badge",
                                                      {
                                                        attrs: {
                                                          variant:
                                                            _vm.severityVariant(
                                                              data.value
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.translateFraudValue(
                                                              data.value
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            1794260723
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                { staticClass: "mt-4" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "d-flex justify-content-end",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _vm.caseData.status !== "Resolved"
                                        ? _c(
                                            "b-button",
                                            {
                                              staticClass: "btnFilter_2 mr-2",
                                              on: { click: _vm.markResolved },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Marquer comme résolu\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "btnFilter_2",
                                          on: { click: _vm.exportCase },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa-light fa-upload",
                                          }),
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "mandate.fraud_case.export_case_pdf"
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("b-card", { staticClass: "text-center py-5" }, [
                            _c("span", { staticClass: "noResult" }, [
                              _vm._v(
                                _vm._s(_vm.$t("mandate.fraud_case.not_found"))
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }